export default __webpack_public_path__ + "static/media/dados-figura1.f0c156ff.png";